import { post } from 'edrolo/domains/net/api';
import urlResolver from 'edrolo/utils/URLResolver';

export const setKeystoreItem = (key, value) => {
  const url = urlResolver.reverse('api:set-profile-key-store-item');
  const data = { key, value };
  return post(url, data);
};
